import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import FingoThemeStrategy from './strategies/FingoThemeStrategy';
import BCHThemeStrategy from './strategies/BCHThemeStrategy';
import ItauThemeStrategy from './strategies/ItauThemeStrategy';

class ThemeStrategyProvider {
  constructor() {
    this.strategies = new Map();
    this.defaultStrategy = null;
    this.loaded = false;
  }

  loadStrategies() {
    if (this.loaded) return;
    this.register(new FingoThemeStrategy());
    this.register(new BCHThemeStrategy());
    this.register(new ItauThemeStrategy());
    this.setDefaultStrategy(this.strategies.get(REQUESTING_PLATFORM_TO_CODES.FINGO));
    this.loaded = true;
  }

  register(strategy) {
    this.strategies.set(strategy.getPlatformCode(), strategy);
  }

  setDefaultStrategy(strategy) {
    this.defaultStrategy = strategy;
  }

  getStrategy(requestingPlatformCode) {
    if (!this.loaded) this.loadStrategies();
    const normalized = requestingPlatformCode || REQUESTING_PLATFORM_TO_CODES.FINGO;
    return this.strategies.get(normalized) ?? this.defaultStrategy;
  }
}

const themeStrategyProvider = new ThemeStrategyProvider();

export default themeStrategyProvider;
